<template>
    <div class="componentRoot">
        <ButtonRowVue>
            <template v-slot:leftSide>
                <v-col :cols="searchBarCols" class="pr-2">
                    <SearchBarVue :labelArray="['basics.name', 'basics.description']" @search="updateSearchQueue" />
                </v-col>
            </template>


            <v-col cols="auto" v-if="$checkRouterPermission('POST')">
                <v-tooltip :text="$t('basics.new', { type: $t('basics.productType') })">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" @click="showEditProductType($event)" class="primaryButton squareButton"
                            flat><v-icon size="x-large">mdi-plus</v-icon></v-btn>
                    </template>
                </v-tooltip>
            </v-col>
        </ButtonRowVue>

        <TableVue :numPages="numPages" @switchPage="switchPage" id="productTypeTable" :resetPage="resetPage"
            :total="totalCount">
            <thead>
                <tr>
                    <th style="width: 80px"></th>
                    <th class="text-left" @click="switchSortBy('name')" :style="{
                        color: sortBy == 'name' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.name") }}</b>

                            <div v-if="sortBy == 'name'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th v-if="!isMobile">
                        <b style="font-size: medium">{{ $t("basics.description") }}</b>
                    </th>
                    <th v-if="!isMobile" class="text-left" @click="switchSortBy('default_price')" :style="{
                        color: sortBy == 'default_price' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.price") }}</b>
                            <div v-if="sortBy == 'default_price'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="productTypes && productTypes.length > 0">
                <tr v-for="product in productTypes" @click="showEditProductType($event, product)" :key="product.id">
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;">
                        <v-img v-if="product.thumbnail" :src="product.thumbnail" width="64" height="48" contain />
                        <v-tooltip :text="$t('messages.imageMissing')" v-else>
                            <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" :color="product.color_code">mdi-shape</v-icon>
                            </template>
                        </v-tooltip>
                        </div>
                    </td>
                    <td>
                        <v-chip :color="product.color_code">{{ product.name }}</v-chip>
                    </td>
                    <td v-if="!isMobile">
                        {{ product.description }}
                    </td>
                    <td v-if="!isMobile">
                        {{ product.default_price }}€
                    </td>
                    <td class="text-right">
                        <v-tooltip :text="$t('basics.edit', { type: $t('basics.productType') })"
                            v-if="$checkRouterPermission('PATCH')">
                            <template v-slot:activator="{ props }">
                                <v-icon v-bind="props"> mdi-pencil </v-icon>
                            </template>
                        </v-tooltip>
                    </td>
                </tr>
            </tbody>

            <tbody v-else>
                <tr>
                    <td colspan="400">
                        <i>{{ $t("messages.noItems") }}</i>
                    </td>
                </tr>
            </tbody>
        </TableVue>

        <ProductTypeEditVue :refreshDisplay="editProductTypeDrawer" @close="closeEditProductType"
            :productTypeData="activeProductType" @delete="showDeleteProductType"
            :readonly="activeProductType ? !$checkRouterPermission('PATCH') : !$checkRouterPermission('POST')" />

        <DeletionWarningVue :type="'productType'" :additionalMessage="$t('messages.confirmDeletionItem', { item: activeProductType?.name })
            " :refreshDisplay="deleteProductTypeDrawer" @delete="deleteProductType" style="z-index: 1007 !important" />

        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
// Expected location: components/products/ProductTypeEdit.vue
import ProductTypeEditVue from "../../../components/products/ProductTypeEdit.vue";

export default {
    name: "productTypeList",

    data() {
        return {
            productTypes: undefined,

            activeProductType: undefined,
            editProductTypeDrawer: 0,
            deleteProductTypeDrawer: 0,

            currPage: 1,
            numPages: undefined,
            totalCount: undefined,
            resetPage: 0,


            searchQueue: undefined,
            searchParams: undefined,

            filterParams: undefined,

            sortBy: "name",
            sortDirection: true,

            loading: false,

        };
    },

    computed: {
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        searchBarCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 9;
                case "sm":
                    return 6;
                case "md":
                    return 4;
                case "lg":
                    return 4;
                case "xl":
                    return 4;
                case "xxl":
                    return 3;
                default:
                    return 4;
            }
        },
    },

    components: {
        ProductTypeEditVue,
    },

    methods: {
        fetchData() {
            this.setLoading(true);

            let searchParams =
                "?page=" +
                this.currPage +
                "&order=" +
                this.sortBy +
                "&direction=" +
                (this.sortDirection ? "up" : "down");

            if (this.searchParams) {
                searchParams += this.searchParams;
            }

            if (this.searchQueue) {
                searchParams += "&query=" + encodeURIComponent(this.searchQueue);
            }

            if (this.filterParams) {
                searchParams += this.filterParams;
            }

            this.axios
                .get(this.axios.defaults.baseURL + "media/producttypes/" + searchParams)
                .then((resp) => {
                    this.setLoading(false);
                    this.productTypes = resp.data.results;
                    this.totalCount = resp.data.count;

                    if (resp.data.results.length == 0) {
                        this.numPages = 0;
                    } else if (this.currPage == 1) {
                        this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
                    }
                })
                .catch((e) => {
                    this.setLoading(false);
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
        setLoading(value) {
            this.loading = value;
        },
        showEditProductType(event, product) {
            event.preventDefault();
            event.stopPropagation();

            this.activeProductType = product;
            this.editProductTypeDrawer++;
        },
        closeEditProductType(value) {
            this.activeProductType = undefined;
            this.editProductTypeDrawer = 0;

            this.setLoading(false);

            if (value) {
                this.fetchData();
            }
        },
        switchPage(data) {
            this.currPage = data;

            this.fetchData();
        },
        getReadableDatetime(datetime) {
            if (datetime) return this.$moment(datetime).format("DD.MM.YYYY HH:mm");
            else return undefined;
        },
        updateSearchQueue(value) {
            this.resetPage++;
            this.currPage = 1;
            this.searchQueue = value;

            this.fetchData();
        },
        switchSortBy(val) {
            if (this.sortBy != val) {
                this.sortBy = val;
                this.sortDirection = true;
            } else {
                this.sortDirection = !this.sortDirection;
            }

            this.currPage = 1;
            this.resetPage++;

            this.fetchData();
        },
        applyFilter(query) {
            this.resetPage++;
            this.filterParams = query;
            this.fetchData();
        },
        showDeleteProductType() {
            this.deleteProductTypeDrawer++;
        },
        deleteProductType() {
            this.setLoading(true);
            this.axios
                .patch(
                    this.axios.defaults.baseURL +
                    "media/producttypes/delete/" +
                    this.activeProductType.id,
                    {
                        deleted: true,
                    }
                )
                .then(() => {
                    this.setLoading(false);
                    this.deleteProductTypeDrawer = 0;
                    this.editProductTypeDrawer = 0;
                    this.fetchData();
                })
                .catch((e) => {
                    this.setLoading(false);
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>
